import * as Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import getters from './getters'
import Home from './modules/home'
import Prompt from './modules/prompt'
import Prompt2 from './modules/prompt2'
import Detail from './modules/detail'
import Register from './modules/register'
import Doc from './modules/doc'
import Upload from './modules/upload'
import UploadFile from './modules/uploadFile'
import Conversation from './modules/conversation'
import Code from './modules/code'
import Glms from './modules/glms'
import Pay from './modules/pay'
import CloudKnowledge from './modules/cloudKnowledge'
import DarkMode from './modules/darkMode'
import NewDialog from './modules/newDialog'

const store = Vuex.createStore({
  modules: {
    Home,
    Prompt,
    Prompt2,
    Detail,
    Register,
    Upload,
    UploadFile,
    Doc,
    Glms,
    Conversation,
    Code,
    Pay,
    CloudKnowledge,
    DarkMode,
    NewDialog
    // StreamState
  },
  getters,
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      // paths: ['Home', 'Doc'],
      reducer(val) {
        return {
          Home: { ...val.Home, showTeenagersModel: 'hidden' },
          Doc: val.Doc,
          Conversation: {
            dataList: val.Conversation.dataList
          }
        }
      }
    })
  ]
})

export default store
